import { API_ROUTES } from "@/constant";
import NotificationAPI from "@/services/Notification/NotificationConfig";
import { NotificationListResponse, NotificationReadAllResponse } from "@/types/notificationService";

export const getAllNotification = async (params?: any): Promise<NotificationListResponse> => {
  const response = await NotificationAPI.get(API_ROUTES.GET_ALL_NOTIFICATION, { params });
  return response.data;
};

export const notificationReadAll = async (): Promise<NotificationReadAllResponse> => {
  const response = await NotificationAPI.put(API_ROUTES.NOTIFICATION_READ_ALL);
  return response.data;
};
